import { httpClient, HttpError } from 'utils/httpClient';
import { DatosDocente, DatosDocentePayload } from 'types/usuario.types';

export const datosDocenteService = {
  async get(usuarioId: number): Promise<DatosDocente | null> {
    try {
      return await httpClient.get<DatosDocente>(`/datos-docente/${usuarioId}`);
    } catch (e: unknown) {
      if (e instanceof HttpError && e.status === 404) return null;
      throw e;
    }
  },

  save(usuarioId: number, data: DatosDocentePayload): Promise<DatosDocente> {
    return httpClient.post<DatosDocente>(`/datos-docente/${usuarioId}`, data);
  },
};
